<script>
import { mapState } from 'vuex';
import FilterMenu from '../../components/filterMenu.vue';
import GalleryMenu from '../../components/galleryMenu.vue';
import Loading from '../../components/loading.vue';
import Picker from '../../components/picker.vue';

export default {
    name: "exhibition",
    data() {
        return {
            // banner: '',
            artist: [],
            artistActiveIndex: [],
            category: [],
            categoryActiveIndex: [],
            sort: [
                { value: 1, name: this.$t('sort[0]') },
                { value: 2, name: this.$t('sort[1]') },
                { value: 3, name: this.$t('sort[2]') },
            ],
            sortValue: 0,
            topList: [],
            list: [],
            page: 1,
            allPage: 1,
            isLoading: false,
            swiperOptions: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                },
            },
            isShowFilter: false,
            isShowSort: false,
        };
    },
    computed: {
        ...mapState(['galleryHome']),
    },
    components: {
        GalleryMenu,
        FilterMenu,
        Loading,
        Picker
    },
    mounted() {
        this.getCategory();
        this.getList();
    },
    destroyed() {},
    watch: {
        sortValue: 'pathChange',
        '$route': 'pathChange',
    },
    methods: {
        // 路由变更
        pathChange() { 
            this.list = [];
            this.page = 1;
            this.allPage = 1;
            this.getList();
            this.isShowFilter = false;
            this.isShowSort = false;
        },
        // 分类
        getCategory() { 
            this.$store.dispatch('getGalleryCategory', {
                type: 1
            }).then((result) => {
                if (result.code == 100) { 
                    // 置顶和banner
                    this.topList = result.data.banner_exhibition;
                    // this.banner = result.data.banner;
                    // 筛选
                    this.artist = [
                        { name: '艺术家', children: result.data.artist },
                    ]
                    this.category = result.data.category.map(v => {
                        return {
                            ...v,
                            children: [...v.item]
                        }
                    })

                    this.getCheckedIndex();
                }
            }).catch((err) => {
                
            });
        },
        getCheckedIndex() {
            // 路由是否有艺术家id
            if (this.artist.length > 0) { 
                if (this.$route.query.artist) { 
                    // 找到对应的索引
                    let index = this.artist[0].children.findIndex(v => v.id == this.$route.query.artist);
                    if (index != -1) { 
                        // 找到了
                        this.artistActiveIndex = [index];
                    } else {
                        // 没找到
                        this.artistActiveIndex = [null];
                    }
                } else {
                    // 路由没有艺术家id
                    this.artistActiveIndex = [null];
                }
            }
            
            // 路由是否有筛选id
            if (this.category.length > 0) { 
                if (this.$route.query.id) { 
                    const ids = this.$route.query.id.split(',');
                    this.categoryActiveIndex = this.category.map((v, i) => {
                        const checked = v.children.findIndex(item => {
                            return ids.findIndex(v => v == item.id) != -1
                        })
                        return checked != -1 ? checked : null;
                    });
                } else {
                    // 路由没有筛选id
                    this.categoryActiveIndex = this.category.map(() => null);
                }
            }
        },
        // 列表
        getList() { 
            if (this.isLoading) { 
                return;
            }
            this.isLoading = true;
            this.$store.dispatch('getGalleryList', {
                type: 1,
                artist_id: this.$route.query.artist ? this.$route.query.artist : '',
                category_ids: this.$route.query.id ? this.$route.query.id : '',
                limit: 9,
                page: this.page,
                sort: this.sort[this.sortValue].value,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.list = this.list.concat(result.data.list);
                    this.allPage = result.data.last_page;

                    this.getCheckedIndex();
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getList();
        },
        changeValue() { 
            let query = {};
            // 艺术家
            if (this.artistActiveIndex[0] != null) { 
                query.artist = `${this.artist[0].children[this.artistActiveIndex[0]].id}`;
            }
            // 分类
            let arr = [];
            // 根据索引获取id数组
            this.categoryActiveIndex.forEach((v, i) => {
                if (v != null) { 
                    arr.push(this.category[i].children[v].id);
                }
            })
            const ids = arr.join(',');
            if (ids != '') { 
                query.id = ids;
            }
            // 跳转
            this.$router.push({
                path: '/gallery/exhibition',
                query
            })
        },
    },
};
</script>

<template>
    <div class="exhibition layout_body">
        <!-- banner -->
        <div class="banner only_pc">
            <div class="layout_bg" :style="`background-image: url(${galleryHome.exhibition_banner});`"></div>
        </div>
        <div class="layout_main">
            <div class="layout_content">
                <!-- 置顶 -->
                <!-- pc -->
                <div class="top_list flex only_pc" v-if="topList.length > 0">
                    <router-link class="item" v-for="(item, index) in topList" :key="index" :to="`/gallery/exhibition/detail?id=${item.id}`">
                        <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                        <div class="text text_shadow">
                            <div class="type">{{ item.name }}</div>
                            <div class="name">{{ item.desc }}</div>
                            <div class="time">{{ item.start_time }}</div>
                        </div>
                    </router-link>
                </div>
                <!-- 置顶 -->
                <!-- mobile -->
                <div class="only_mobile">
                    <swiper class="top_list_mobile" :options="swiperOptions">
                        <swiper-slide v-for="(item, index) in topList" :key="index">
                            <router-link class="item" v-for="(item, index) in topList" :key="index" :to="`/gallery/exhibition/detail?id=${item.id}`">
                                <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                                <div class="text text_shadow">
                                    <div class="type">{{ item.name }}</div>
                                    <div class="name">{{ item.desc }}</div>
                                    <div class="time">{{ item.start_time }}</div>
                                </div>
                            </router-link>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div>
                <!--  -->
                <div class="only_mobile">
                    <div class="filter_tabs flex">
                        <div class="item" :class="{active: isShowFilter}" @click="isShowFilter = !isShowFilter">
                            <div class="name">筛选</div>
                        </div>
                        <div class="item" :class="{active: isShowSort}" @click="isShowSort = !isShowSort">
                            <div class="name">{{ sort[sortValue].name }}</div>
                        </div>
                    </div>
                    <div class="filter" v-if="isShowFilter">
                        <FilterMenu :data="artist" v-model="artistActiveIndex" @change="changeValue"/>
                        <FilterMenu :data="category" v-model="categoryActiveIndex" @change="changeValue"/>
                    </div>
                    <div class="sort" v-if="isShowSort">
                        <div class="item" v-for="(item, index) in sort" :key="index" @click="sortValue = index">{{ item.name }}</div>
                    </div>
                </div>
                <!--  -->
                <div class="tags flex justify_end align_center only_pc">
                    <Picker :data="sort" v-model="sortValue"/>
                </div>
                <div class="wrapper flex">
                    <div class="filter only_pc" v-if="artist.length > 0 || category.length > 0">
                        <FilterMenu :data="artist" v-model="artistActiveIndex" @change="changeValue"/>
                        <FilterMenu :data="category" v-model="categoryActiveIndex" @change="changeValue"/>
                    </div>
                    <div class="content">
                        <div class="exhibition_list flex flex_wrap">
                            <router-link class="item" v-for="(item, index) in list" :key="index" :to="`/gallery/exhibition/detail?id=${item.id}`">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <div class="name">{{ item.name }}</div>
                                <div class="time flex align_center">
                                    <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                                    <p>{{ item.start_time }} - {{ item.end_time }}</p>
                                </div>
                                <div class="price flex align_center">
                                    <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                    <p v-if="item.price == '0.00'">免费</p>
                                    <p v-else>RMB {{ item.price }}</p>
                                </div>
                                <!-- <div class="flex justify_between align_center price_wrapper">
                                    <div class="price flex align_center">
                                        <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                        <p v-if="item.price == '0.00'">免费</p>
                                        <p v-else>RMB {{ item.price }}</p>
                                    </div>
                                    <div class="link layout_flex_center">了解更多</div>
                                </div> -->
                            </router-link>
                        </div>
                        <Loading v-if="isLoading"/>
                        <p class="no_more" v-else-if="list.length == 0">暂无更多内容</p>
                        <p class="no_more" v-else-if="page == allPage">已经到底了</p>
                        <div class="flex justify_end" v-else>
                            <div class="layout_btn_more" @click="getMore">更多展览</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
}
.layout_content{
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
}
.tags{
    margin-bottom: .3rem;
}
.top_list_mobile{
    width: 7.5rem;
    height: 6.3rem;
    margin: 0 -.3rem;
    .item{
        position: relative;
        .text{
            position: absolute;
            left: 0;
            bottom: .6rem;
            width: 100%;
            color: #fff;
            text-align: center;
            .type{
                font-size: .26rem;
                margin-bottom: .1rem;
            }
            .name{
                font-size: .32rem;
                margin-bottom: .1rem;
            }
            .time{
                font-size: .22rem;
            }
        }
    }
    .swiper-pagination{
        display: flex;
        justify-content: center;
        gap: .1rem;
        bottom: .3rem;
        display: none;
        @media only screen and (max-width: 750px) {
            display: flex;
        }
        /deep/ .swiper-pagination-bullet{
            opacity: 1;
            margin: 0;
            width: .12rem;
            height: .12rem;
            background: none;
            border: 1px solid #fff;
            &-active{
                background: #fff;
            }
        }
    }
}
.top_list{
    gap: .4rem;
    margin-bottom: .6rem;
    .item{
        // flex: 1;
        width: 5.4rem;
        position: relative;
        .bg{
            height: 0;
            padding-bottom: 63.55%;
            // border: 1px solid #000;
        }
        .text{
            position: absolute;
            left: .4rem;
            bottom: .4rem;
            width: 100%;
            color: #fff;
            .type{
                font-size: .24rem;
            }
            .name{
                font-size: .25rem;
                font-weight: bold;
            }
            .time{
                font-size: .18rem;
            }
        }
    }
}
.filter_tabs{
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
    height: .7rem;
    margin: 0 -.3rem;
    .item{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #999;
        &.active{
            &::after{
                transform: translate(0, 25%) rotate(-135deg);
            }
        }
        &:last-child{
            border-right: none;
        }
        .name{
            text-align: center;
        }
        &::after{
            content: "";
            display: block;
            width: .14rem;
            height: .14rem;
            border-right: 1px solid #999;
            border-bottom: 1px solid #999;
            transform: translate(0, -25%) rotate(45deg);
            margin-left: .2rem;
        }
    }
}
.filter,
.sort{
    @media only screen and (max-width: 750px) {
        margin: 0 -.3rem;
    }
}
.sort{
    padding: .3rem .6rem;
    border-bottom: 1px solid #999;
    .item{
        line-height: .6rem;
        font-size: .32rem;
    }
}
.sort_picker{
    margin-bottom: .3rem;
}
.wrapper{
    gap: .5rem;
}
.content{
    flex: 1;
    @media only screen and (max-width: 750px) {
        padding: .3rem 0;
    }
}
.exhibition_list{
    gap: .39rem;
    @media only screen and (max-width: 750px) {
        gap: .3rem;
    }
    .item{
        width: 2.54rem;
        @media only screen and (max-width: 750px) {
            width: 3.3rem;
        }
        .cover{
            height: 0;
            padding-bottom: 100%;
            margin-bottom: .1rem;
            // 
            // border: 1px solid #000;
        }
        .name{
            font-size: .18rem;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .28rem;
                text-align: center;
            }
        }
        .time,
        .price{
            font-size: .16rem;
            color: #666;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
        .price_wrapper{
            @media only screen and (max-width: 750px) {
                flex-direction: column;
            }
        }
        .time{
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                justify-content: center;
            }
        }
        .icon{
            margin-right: .1rem;
            &.calendar{
                width: .21rem;
            }
            &.price{
                width: .24rem;
            }
            @media only screen and (max-width: 750px) {
                &.calendar{
                    width: .29rem;
                }
                &.price{
                    width: .32rem;
                }
            }
        }
        .link{
            font-size: .16rem;
            color: #666;
            border-bottom: 1px solid #666;
            cursor: pointer;
            @media only screen and (max-width: 750px) {
                font-size: .24rem;
                border-bottom: none;
                color: #999;
            }
        }
    }
}
.layout_btn_more{
    border-bottom: 1px solid #666;
    @media only screen and (max-width: 750px) {
        margin: .3rem auto 0;
    }
}
</style>